// Carga/guardado del constructor de páginas. FUENTE ÚNICA: activity_groups.reports.detailed
// (el mismo que consume el generador de informe). Al cargar reconstruye el estado del
// builder desde detailed; al guardar escribe detailed (claves reales + settings del builder
// para round-trip) y estampa code_custom en los grupos de las disciplinas.
import { fetchConfigActivityGroups, persistActivityGroupConfig, assignCustomCodesToActivityGroups } from '·/components/activity-groups/api/index'
import { builderToDetailed, detailedToBuilder, disciplineGroupMappings } from './page-builder.converge'

export async function loadBuilderConfig(projectId) {
  const activityGroups = (await fetchConfigActivityGroups(projectId)) || {}
  const detailed = activityGroups.reports && activityGroups.reports.detailed
  const hasContent = detailed && ((detailed.pages && detailed.pages.length) || (detailed.sections && detailed.sections.length))
  return { builder: hasContent ? detailedToBuilder(detailed) : null }
}

export async function saveBuilderConfig(projectId, builderJson) {
  // Relee el estado actual del servidor y solo reescribe reports.detailed (preserva view y
  // cualquier otra clave bajo reports).
  const current = (await fetchConfigActivityGroups(projectId)) || {}
  if (!current.reports) current.reports = {}
  current.reports.detailed = builderToDetailed(builderJson)
  await persistActivityGroupConfig(projectId, { activity_groups: current })

  // Enganche disciplina↔grupo: estampa code_custom en los grupos vinculados.
  const mappings = disciplineGroupMappings(builderJson)
  if (mappings.length) {
    try { await assignCustomCodesToActivityGroups(mappings) } catch (e) { /* no bloquea el guardado del builder */ }
  }
}
